import { createContext, ReactNode, useCallback, useMemo, useState } from 'react';
import { carProps } from '../CarDetails';

type Car = {
  id: number;
  name: string;
  brand: string;
  km: number;
  price: string;
  fipePrice?: string;
  thumbnail: string;
  year: number;
  yearModel: number;
}

type Order = {
  id: number;
  userId: number;
  vehicles: Car[];
  createdDate: string;
  updatedDate: string;
  canceledDate: string;
}

export type CarsContextData = {
  cars: Car[],
  carSelected: carProps[],
  setCarSelected: (car: carProps[]) =>  void,
  setCarSelectedContext: React.Dispatch<React.SetStateAction<carProps[]>>,
  setCars: (cars: Car[]) => void,
  removeCarSelected: (id: number) => void,
  order: Order[];
  setOrder: (order: Order[]) => void,
  hasOrder:boolean;
  setHasOrder: React.Dispatch<React.SetStateAction<boolean>>,

}

type PropsWithRequiredChildren<T = unknown> = T & {
  children: ReactNode;
}

export const CarsContext = createContext<CarsContextData>({} as CarsContextData);

export const CarsProvider = ({children}: PropsWithRequiredChildren) => {
  const [hasOrder, setHasOrder] = useState(false)
  const [orderContext, setOrderContext] = useState<Order[]>([]);

  const [carsSelectedContext, setCarSelectedContext] = useState<carProps[]>(() => {
    const carsSelectedLocal = localStorage.getItem('@pepsico-carSelected')

    if (carsSelectedLocal) {
      const carsSelected = JSON.parse(carsSelectedLocal);

      return carsSelected;
    }

    return [] as carProps[];
  })
  const [carsContext, setCarsContext] = useState<Car[]>([])

  const setCars = useCallback((cars: Car[]) => {
    setCarsContext(cars)
  }, []);

  const setCarSeleted = useCallback((cars: carProps[]) => {
    setCarSelectedContext((prevState) => {
      if(hasOrder) {
        return cars
      }

      const newState = [...prevState, ...cars]

      return newState;
    });
  }, [hasOrder]);

  const removeCarSelected = useCallback((id: number) => {

    setCarSelectedContext(prevState => {
      const hasCar = prevState.find(car => car.id === id);

      if (!hasCar) {
        throw new Error('Car does not exists')
      }

      const removeCar = prevState.filter(car => car.id !== id)
      return removeCar
    })
  }, []);

  const setOrder = useCallback((order: Order[]) => {
    setOrderContext(order);
  }, []);

  const value = useMemo<CarsContextData>(() => ({
    cars: carsContext,
    carSelected: carsSelectedContext,
    setCarSelected: setCarSeleted,
    setCars,
    removeCarSelected,
    setCarSelectedContext,
    order: orderContext,
    setOrder,
    hasOrder,
    setHasOrder,
  }), [
    carsContext,
    setCars,
    carsSelectedContext,
    setCarSeleted,
    removeCarSelected,
    setOrder,
    orderContext,
    hasOrder,
    setHasOrder,
  ])


  return <CarsContext.Provider value={value}>
    {children}
  </CarsContext.Provider>
}